import { HeadingTitle } from './HeadingTitle';

export default HeadingTitle;
